export default __webpack_public_path__ + "static/char-s-59-ja-db4893af3c8df09104ee26eeb6451395.png";